export default function userFromToken() {
  const token = window.localStorage.getItem("auth-token")
  if (token) {
    const [, payload] = token.split(".")
    const user = JSON.parse(atob(payload))
    return user
  }
}
